import {Toast} from 'mint-ui';
import {request} from '@/common/util/request';

let urls = {
    getProvincial: '/i/wechat/api/city',
    getGrade: '/i/wechat/api/grade'
};

let actions = {
    getProvincialInfo(context) {
        return request({
            'url': urls.getProvincial
        }).then((res)=>{
            let result = res.data ? res.data : {};
            // data 判断
            if (result.error_code == 0) {
                context.commit('provinceInfo', result.data);
            } else {
                Toast(result.error_msg || '省市配置信息获取失败！')
            }
            return result;
        }).catch((error) => {
            Toast('页面暂时无法访问，请稍后重试！');
        });
    },
    getGradeInfo(context) {
        return request({
            'url': urls.getGrade
        }).then((res) => {
            let result = res.data ? res.data : {};
            if (result.error_code == 0) {
                context.commit('gradeInfo', result.data);
            } else {
                Toast(result.error_msg || '年级信息获取失败')
            }
            return result;
        }).catch((error) => {
            Toast('页面暂时无法访问，请稍后重试！');
        });
    }
}
export default actions;


// WEBPACK FOOTER //
// ./src/vuex/modules/provincialGrade/actions.js